import { useCallback, useSyncExternalStore } from 'react';

import { featureFlagClient } from './core/featureFlagClient';
import type { FeatureFlagProvider } from './core/featureFlagClient.types';
import type {
  FeatureFlagKey,
  FeatureFlagKind,
  PortalFeatureFlagDefinition,
} from './featureFlagDefinition';

type AnyPortalFeatureFlagDefinition = PortalFeatureFlagDefinition<
  FeatureFlagKey,
  FeatureFlagProvider,
  FeatureFlagKind
>;

export function useFeatureFlagReady(definition: AnyPortalFeatureFlagDefinition): boolean {
  const { provider } = definition;
  const subscribe = useCallback(
    (onStoreChange: () => void) => featureFlagClient.onChange(onStoreChange, { provider }),
    [provider]
  );
  const getSnapshot = useCallback(() => featureFlagClient.isReady({ provider }), [provider]);
  const getServerSnapshot = useCallback(() => false, []);

  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
